import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { HelperServiceProvider } from "./../common/services/helper.service";
import { APIServiceProvider } from "./../common/services/api.service";

@Injectable() //{providedIn: 'root'}
export class InterceptureService implements HttpInterceptor {
  private totalRequests = 0;

  // tslint:disable-next-line:indent
  constructor(
    public helperService: HelperServiceProvider,
    public apiService: APIServiceProvider
  ) {}

  // intercept request and add token
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.totalRequests++;
    //Show loading

    return next.handle(request).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            this.decreaseRequests();
          }
        },
        error => {
          this.decreaseRequests();

          if (error.status === 401 && error.error.msg === "Token has expired") {
            this.requestForNewToken(); 
          }

          if (error.status === 422 && error.error && error.error.msg) {
            this.helperService.presentToast(error.error.msg)
          }
          if (error.status === 400 && error.error && error.error.data && error.error.data.message) { 
            this.helperService.presentToast(error.error.data.message)
          }
        }
      )
    );
  }

  private decreaseRequests() {
    this.helperService.dismissLoader();
    this.totalRequests--;
    if (this.totalRequests === 0) {
      //Hide loading
    }
  }

  private requestForNewToken() {
    this.apiService.post("auth/token/refresh", {}).subscribe(
      response => {
        localStorage.setItem("gp_token", response["data"]);
      },
      error => {
        if (error["error"]["error"]) {
          var message = error["error"]["msg"];

          this.helperService.presentToast(message);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/intercepture.service.ts